export default __webpack_public_path__ + "static/media/regulatory--light-rail-do-not-pass--g1.a6efedce.png";